import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Pagination, AccessControl } from '~core/models/core.models';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class AccessControlsService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  list(): Observable<Pagination<AccessControl>> {
    return this._httpClient.get<Pagination<AccessControl>>(
      `${this._apiConstantsService.accessControlsUrl}`
    );
  }
}
